/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** Details about the error. */
export interface Error {
  /**
   * Machine-readable error code.
   * @example "ConstraintViolationError"
   */
  code?: string;
  /**
   * Human-readable error message.
   * @example "The request was malformed."
   */
  message?: string;
  /**
   * Optional field used to point to a problematic part of the request.
   * @example "31192dc9-eb45-4d90-b606-21e9b66d8c2b"
   */
  target?: string;
  details?: Error[];
}

export interface ErrorResponse {
  /**
   * A correlation id used for reference when contacting support.
   * @example "7b8514e6-230d-41cc-b3c2-512bca15abf0"
   */
  requestId?: string;
  /** Details about the error. */
  error?: Error;
}

export interface Link {
  /**
   * An absolute URL linking to a resource.
   * @example "https://..."
   */
  href?: string;
}

export interface Links {
  next?: Link;
  previous?: Link;
}

/** A typed model which describes a restriction pertaining to a platform entity. */
export interface Restriction {
  /** The restriction level of an entity to limit actions it can take. */
  tier: number;
  /** The number of days to retain the state before deletion. */
  historyRetentionTTLDays?: number;
  /**
   * Indicate whether or not the entity is visible when restricted.
   * @default false
   */
  visibleWhenRestricted?: boolean;
}

/** A paginated array of Devices. */
export interface PagedDevices {
  items?: Device[];
  _links?: Links;
}

export interface SharedLocation {
  /** @example "1c75f712-2c3e-4e51-970c-a42ae7aedbdc" */
  locationId?: string;
}

/** The description of an attribute value that will be used to populate an event. */
export interface AttributeValue {
  /** The attribute that this command will correspond to */
  attribute?: string;
  /** How will the attribute be provided? Choose either to provide it with a command at runtime or to provide a set value here. */
  inputType?: 'STATIC' | 'ARGUMENT';
  /** The argument to be used automatically for this command mapping. Any simple type is accepted. */
  staticValue?: object;
}

export interface UpdateDeviceComponent {
  /** @example "main" */
  id: string;
  /**
   * The label for the device component.
   * @minLength 1
   * @maxLength 255
   * @example "Living room light switch 2"
   */
  label?: string;
  /**
   * Identifier allowing the user to pick a custom icon for the device component.
   * The icon of the main component represents the device itself
   * @minLength 1
   * @maxLength 255
   */
  icon?: string;
  /**
   * A case-sensitive string from the pre-defined list of valid categories [/devicecategories](#/operation/listCategories). Allows the user to redefine the category of the device from what the manufacturer set by default.
   * @maxItems 1
   * @minItems 1
   */
  categories: string[];
}

export interface DeviceComponent {
  /**
   * @format ^[-_!.~'()*0-9a-zA-Z]{1,36}$
   * @example "main"
   */
  id: string;
  /** UTF-8 label for the component. */
  label?: string;
  capabilities: DeviceCapabilityReference[];
  /** Defines the categories for the device. There can be up to 2, one defined by the manufacturer the other is a user selected value. */
  categories: DeviceCategory[];
  /** A typed model which describes a restriction pertaining to a platform entity. */
  restrictions?: Restriction;
  /** For internal use only */
  icon?: string;
}

export interface CapabilityConfiguration {
  values: CapabilityConfigurationValue[];
}

export type CapabilityReference = CapabilityReferenceRequest & {
  /** @example false */
  ephemeral?: boolean;
};

/**
 * A mapping of `commandName` to `attribute.value` that will allow users to support complex commands that would otherwise
 * not be determinable simply by the capabililty contract.
 */
export interface CommandMapping {
  /** The Capability ID. */
  capabilityId: string;
  /** The Capability version number. */
  version: number;
  /** The command name to apply the mapping to on the device */
  command: string;
  /** A collection of attribute values, replicator will use these to create device events in serial for the specified command. */
  eventValues: AttributeValue[];
}

export interface CommandMappings {
  commands?: CommandMapping[];
}

export type CapabilityReferenceRequest = BaseCapabilityReference & {
  config?: CapabilityConfiguration;
  /** A typed model which describes a restriction pertaining to a platform entity. */
  restrictions?: Restriction;
};

export interface BaseCapabilityReference {
  /** @example "switch" */
  id: string;
  /** @example 1 */
  version?: number;
}

export interface CapabilityConfigurationValue {
  /**
   * The path to the preference attribute that is being configured.
   * @example "thermostatMode.value"
   */
  key: string;
  /**
   * The range of values supported by the capability attribute. The range must be a subset of the one defined on the capability. Either `range` OR `enabledValues` must be provided, not both.
   * @maxItems 2
   * @minItems 2
   * @example "[1, 50]"
   */
  range?: number[];
  /**
   * The list of enumerated values that are supported for the capability attribute. The list of supported value must be a subset of the one defined on the capability. Either `range` OR `enabledValues` must be provided, not both.
   * @example "[ "cooling", "fan only", "heating", "idle" ]"
   */
  enabledValues?: string[];
  /**
   * The incremental step that increases or decreases for numeric values.
   * @format double
   * @default 1
   */
  step?: number;
}

export type DeviceCapabilityReference = CapabilityReference & {
  /** A map of Attribute name to Attribute state. */
  status?: CapabilityStatus;
};

/** A case-sensitive string from the pre-defined list of valid categories [/devicecategories](#/operation/listCategories). */
export interface DeviceCategory {
  /** @example "Light" */
  name: string;
  /** @default "manufacturer" */
  categoryType: 'manufacturer' | 'user';
}

/**
 * A map of Attribute name to Attribute state.
 * @example {"switch":{"value":"on"}}
 */
export type CapabilityStatus = Record<string, AttributeState>;

export interface AttributeState {
  /** @example 0 */
  value?: object;
  /** @example "°C" */
  unit?: string;
  /** @example {"method":"manual","codeId":1234,"timeout":"2018-05-09T23:03:31+0000"} */
  data?: Record<string, object>;
  /**
   * Will always be 0 timezone offset
   * @format date-time
   * @example "2017-12-18T22:14:52.714Z"
   */
  timestamp?: string;
}

export interface IdLessHealthState {
  /** Current state of the device */
  state?: 'ONLINE' | 'OFFLINE';
  /**
   * Last reported date/time in UTC
   * @format date-time
   */
  lastUpdatedDate?: string;
}

export interface ChildDeviceRef {
  /** @example "1c75f712-2c3e-4e51-970c-a42ae7aedbdc" */
  id?: string;
}

export interface DeviceProfileReference {
  /**
   * The device profile Id
   * @example "a7b3c264-2d22-416e-bca1-ca4b59a60aee"
   */
  id?: string;
}

export interface AppDeviceDetails {
  /**
   * The ID of the installed app that integrates this device.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  installedAppId?: string;
  /**
   * A field to store an ID from a system external to SmartThings.
   * @maxLength 64
   * @example "Th13390"
   */
  externalId?: string;
  profile?: DeviceProfileReference;
}

export type BleDeviceDetails = object;

export interface BleD2DDeviceDetails {
  /**
   * Security encryption key.
   * @example "96012869B606355A1F843B1E19DC31B1"
   */
  encryptionKey?: string;
  /**
   * Key for the decrypt.
   * @example "BMO_256-CBS-PKMS1Padding"
   */
  cipher?: string;
  /**
   * BLE Advertising Id.
   * @example "9C0D4219"
   */
  advertisingId?: string;
  /**
   * Unique device identifier.
   * @example "88-57-1d-0e-53-ab"
   */
  identifier?: string;
  configurationVersion?: string;
  /** @example "https://apisa.samsungiots.com/v1/miniature/profile/e524ceba-93b9-499d-a90a-24214f7f01cb" */
  configurationUrl?: string;
  metadata?: object;
}

export interface DthDeviceDetails {
  /** True if the device setup has been completed so the device is ready to use. */
  completedSetup: boolean;
  /** The device network type. */
  deviceNetworkType?: DeviceNetworkType;
  /**
   * The identifier for the device's DeviceType.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "7b8514e6-230d-41cc-b3c2-512bca15abf0"
   */
  deviceTypeId: string;
  /**
   * The name for the device's DeviceType.
   * @example "x.com.samsung.da.fridge"
   */
  deviceTypeName: string;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /**
   * The ID of the installed groovy application
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "8f5ra619-4c05-4a90-a245-cc129b0a8098"
   */
  installedGroovyAppId?: string;
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /**
   * For hub-connected devices on protocols with multiple security levels, the security level the device was added with.
   * Values ZWAVE_S2_FAILED, ZWAVE_S0_FAILED, ZWAVE_S2_DOWNGRADE, and ZWAVE_S0_DOWNGRADE should be treated as failures
   * and prompt the user to remove and re-add the device. Other Z-Wave values are success cases.
   */
  networkSecurityLevel?: DeviceNetworkSecurityLevel;
}

/**
 * The device network type.
 * @example "ZIGBEE"
 */
export type DeviceNetworkType = string;

/** True if the device is executing locally on the hub */
export type ExecutingLocally = boolean;

/**
 * The hub that the device is connected to.
 * @example "f7239728-edb3-48e9-b588-a27f30b968a0"
 */
export type HubId = string;

/**
 * For hub-connected devices on protocols with multiple security levels, the security level the device was added with.
 * Values ZWAVE_S2_FAILED, ZWAVE_S0_FAILED, ZWAVE_S2_DOWNGRADE, and ZWAVE_S0_DOWNGRADE should be treated as failures
 * and prompt the user to remove and re-add the device. Other Z-Wave values are success cases.
 * @default "UNKNOWN"
 */
export enum DeviceNetworkSecurityLevel {
  UNKNOWN = 'UNKNOWN',
  ZWAVE_LEGACY_NON_SECURE = 'ZWAVE_LEGACY_NON_SECURE',
  ZWAVES0LEGACY = 'ZWAVE_S0_LEGACY',
  ZWAVES0FALLBACK = 'ZWAVE_S0_FALLBACK',
  ZWAVES2UNAUTHENTICATED = 'ZWAVE_S2_UNAUTHENTICATED',
  ZWAVES2AUTHENTICATED = 'ZWAVE_S2_AUTHENTICATED',
  ZWAVES2ACCESSCONTROL = 'ZWAVE_S2_ACCESS_CONTROL',
  ZWAVES2FAILED = 'ZWAVE_S2_FAILED',
  ZWAVES0FAILED = 'ZWAVE_S0_FAILED',
  ZWAVES2DOWNGRADE = 'ZWAVE_S2_DOWNGRADE',
  ZWAVES0DOWNGRADE = 'ZWAVE_S0_DOWNGRADE',
}

/** Device Profile information for Lan devices. This field will be empty if device type is not LAN. */
export interface LanDeviceDetails {
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /** Provisioning type for a widget device */
  provisioningState?: ProvisioningState;
}

/** The network-specific identifier of the device on the network */
export type DeviceNetworkId = string;

/**
 * The ID of the Sprocket driver
 * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
 * @example "9314a926-528c-403f-ae56-4b0d059381dd"
 */
export type DriverId = string;

/** The identifier assigned to this edge child device by its parent */
export type ParentAssignedChildKey = string;

/** Provisioning type for a widget device */
export enum ProvisioningState {
  PROVISIONED = 'PROVISIONED',
  TYPED = 'TYPED',
  DRIVER_SWITCH = 'DRIVER_SWITCH',
  NONFUNCTIONAL = 'NONFUNCTIONAL',
}

/** Device Profile information for Zigbee devices. This field will be empty if device type is not ZIGBEE. */
export interface ZigbeeDeviceDetails {
  /** The EUID of the Zigbee device */
  eui?: DeviceEui;
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /** Provisioning type for a widget device */
  provisioningState?: ProvisioningState;
}

/**
 * The EUID of the Zigbee device
 * @example "24FD5B000105DB96"
 */
export type DeviceEui = string;

/**
 * 16-bit manufacturer identifier assigned by the Z-Wave Specification
 * @min 0
 * @max 65535
 * @example 134
 */
export type ZWaveManufacturerId = number;

/**
 * 16-bit manufacturer defined product type
 * @min 0
 * @max 65535
 * @example 17488
 */
export type ZWaveProductType = number;

/**
 * 16-bit manufacturer defined product identifier
 * @min 0
 * @max 65535
 * @example 12336
 */
export type ZWaveProductId = number;

/** Device Profile information for Z-Wave devices. This field will be empty if device type is not ZWAVE. */
export interface ZwaveDeviceDetails {
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /**
   * For hub-connected devices on protocols with multiple security levels, the security level the device was added with.
   * Values ZWAVE_S2_FAILED, ZWAVE_S0_FAILED, ZWAVE_S2_DOWNGRADE, and ZWAVE_S0_DOWNGRADE should be treated as failures
   * and prompt the user to remove and re-add the device. Other Z-Wave values are success cases.
   */
  networkSecurityLevel?: DeviceNetworkSecurityLevel;
  /** Provisioning type for a widget device */
  provisioningState?: ProvisioningState;
  /** 16-bit manufacturer identifier assigned by the Z-Wave Specification */
  manufacturerId?: ZWaveManufacturerId;
  /** 16-bit manufacturer defined product type */
  productType?: ZWaveProductType;
  /** 16-bit manufacturer defined product identifier */
  productId?: ZWaveProductId;
}

/** Device Profile information for Matter devices. This field will be empty if the device type is not MATTER */
export interface MatterDeviceDetails {
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /** Provisioning type for a widget device */
  provisioningState?: ProvisioningState;
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** Vendor-supplied unique identifier. Optional. */
  uniqueId?: string;
  /** 16-bit vendor id. Optional. */
  vendorId?: number;
  /** 16-bit product id. Optional. */
  productId?: number;
  /** Listening type for the device. Optional. */
  listeningType?: MatterListeningType;
  /** List of network interfaces. Optional. */
  supportedNetworkInterfaces?: MatterNetworkInterfaces;
  /** Hardware and Software version info for matter devices. Optional. */
  version?: MatterVersion;
  /** Available Matter endpoints */
  endpoints?: MatterEndpoints;
  /** Determines whether or not to sync the child device's driver from its parent. Default is true. */
  syncDrivers?: SyncDrivers;
}

/** Device Profile information for Edge Child devices. This field will be empty if the device type is not EDGE_CHILD */
export interface EdgeChildDeviceDetails {
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /** Provisioning type for a widget device */
  provisioningState?: ProvisioningState;
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** The identifier assigned to this edge child device by its parent */
  parentAssignedChildKey?: ParentAssignedChildKey;
}

/** HUB device information. This field will be empty if the device type is not HUB. */
export interface HubDeviceDetails {
  /**
   * The unique identifier for this manufactured hub.
   * @format ^[0-9A-F]{16}$
   * @example "D053A8B4F6D80001"
   */
  hubEui: string;
  /**
   * The hub's firmware version
   * @format ^[0-9]\.[0-9]\.[0-9]{3}$
   * @example ""
   */
  firmwareVersion: string;
  /** A list of drivers installed on the hub */
  hubDrivers: HubDriver[];
  hubData: {
    /** will be true if the hub is secondary, false otherwise */
    isSecondary?: boolean;
    /**
     * Zwave static DSK for the hub.
     * @example "21720-31296-41384-03009-58023-25366-38831-43982"
     */
    zwaveStaticDsk?: string;
    /** Whether zwaveS2 is enabled for this hub. */
    zwaveS2: boolean;
    /**
     * The hardwareType for this hub
     * @example "V3_HUB"
     */
    hardwareType: string;
    /**
     * The hub's hardware ID
     * @example "00A2"
     */
    hardwareId?: string;
    /**
     * The Zigbee firmware version for this hub
     * @example "5.4.0"
     */
    zigbeeFirmware?: string;
    /** Whether the hub supports zigbee3 */
    zigbee3: boolean;
    /** Describes state of Zigbee OTA */
    zigbeeOta?: string;
    /** Indicates if Zigbee OTA is enabled. */
    otaEnable?: string;
    /** Whether the hub allows zigbee unsecure rejoin */
    zigbeeUnsecureRejoin: boolean;
    /** Possible Values for Hub Characteristic "Availability" flags */
    primarySupportAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    secondarySupportAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    zigbeeAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    zwaveAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    threadAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    lanAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    matterAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    localVirtualDeviceAvailability?: AvailabilityCharacteristic;
    /** The primary hub device id for this hub. Null/Empty if hub is not a repeater. */
    primaryHubDeviceId?: string;
    /** The Zigbee Channel of the Hub. */
    zigbeeChannel?: string;
    /** The Personal Area Network (PAN) id of the zigbee network the hub is on. */
    zigbeePanId?: string;
    /** The unique identifier for this manufactured hub. */
    zigbeeEui?: string;
    /** The short address of a node in Zigbee network. */
    zigbeeNodeID?: string;
    /** The address of a single node in the network */
    zwaveNodeID?: string;
    /** The common identification of all nodes belonging to one logical Z-Wave network */
    zwaveHomeID?: string;
    zwaveSucID?: string;
    zwaveVersion?: string;
    /** The global region this zwave radio is operating in. */
    zwaveRegion?: string;
    /** MAC address of the hubs network interface. */
    macAddress?: string;
    /** IP address of the hub. */
    localIP?: string;
    /** Whether the hub is zigbee radio functional. */
    zigbeeRadioFunctional?: boolean;
    /** Whether the hub is zwave radio functional. */
    zwaveRadioFunctional?: boolean;
  };
}

/** MOBILE device information. This field will be empty if the device type is not MOBILE. */
export type MobileDeviceDetails = object;

export interface IrDeviceDetails {
  /**
   * The id of the Parent device.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  parentDeviceId?: string;
  /**
   * The id of the profile that describes the device components and capabilities.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "0c0b875r-0213-6479-a0bf-da7aeec3dc0a"
   */
  profileId?: string;
  /**
   * The OCF Device Type
   * @example "oic.d.tv"
   */
  ocfDeviceType?: string;
  /**
   * The id of the ircode
   * @example "006C"
   */
  irCode?: string;
  /**
   * List of IR function codes
   * @example {"statelessPowerToggleButton.powerToggle":"power","statelessAudioMuteButton.muteToggle":"mute","statelessAudioVolumeButton.volumeUp":"volume_up","statelessAudioVolumeButton.volumeDown":"volume_down","statelessChannelButton.channelUp":"channel_up","statelessChannelButton.channelDown":"channel_down","statelessCustomButton.green":"green","statelessCustomButton.right":"right","statelessCustomButton.3":3,"statelessCustomButton.exit":"exit","statelessCustomButton.playback":"playback"}
   */
  functionCodes?: {
    default?: string;
    [key: string]: any;
  };
  /** list of child devices */
  childDevices?: IrDeviceDetails[];
  /**
   * Key value pairs stored in the conductor for the device.
   * UI Metadata information
   */
  metadata?: Record<string, any>;
}

export interface OcfDeviceDetails {
  /** OCF device type */
  ocfDeviceType?: string;
  /** Name of the device */
  name?: string;
  /** OCF spec version */
  specVersion?: string;
  /** OCF vertical domain spec version */
  verticalDomainSpecVersion?: string;
  /** OCF manufacturer name */
  manufacturerName?: string;
  /** OCF model number */
  modelNumber?: string;
  /** OCF platform version */
  platformVersion?: string;
  /** OCF platform OS */
  platformOS?: string;
  /** OCF platform H/W version */
  hwVersion?: string;
  /** OCF firmware version */
  firmwareVersion?: string;
  /** OCF vendor ID */
  vendorId?: string;
  /** OCF vendor resource client/server version */
  vendorResourceClientServerVersion?: string;
  /** Language code */
  locale?: string;
  /** The time when the device is signed up lastly */
  lastSignupTime?: string;
}

export interface ViperDeviceDetails {
  /** @example "1a-74" */
  uniqueIdentifier?: string;
  /** @example "TP-Link" */
  manufacturerName?: string;
  /** @example "HS101" */
  modelName?: string;
  /** @example "23.123.231" */
  swVersion?: string;
  /** @example "v1 US bulb" */
  hwVersion?: string;
  /** @example "viper_bb238c20-675a-11ed-970f-571777eb58c5" */
  endpointAppId?: string;
}

export interface GroupDeviceDetails {
  /** @example "My Group" */
  groupName?: string;
  /** The type of the device group */
  groupType?: DeviceGroupType;
  devices?: {
    /**
     * GUID representing the device
     * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
     * @example "747d79d3-4685-4852-89b6-e2fc681a590f"
     */
    deviceId: string;
    /** Components to add to the group */
    components?: {
      /** @example "main" */
      id?: string;
      [key: string]: any;
    }[];
  }[];
}

export interface VirtualDeviceDetails {
  /** Name of the device */
  name?: string;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  commandMappings?: CommandMappings;
}

export interface HubDriver {
  /** The version of the driver revision being returned */
  driverVersion?: string;
  /**
   * The identifier of the Sprocket driver
   * @format uuid
   * @example "9314a926-528c-403f-ae56-4b0d059381dd"
   */
  driverId: string;
  /**
   * The identifier of the Sprocket channel
   * @format uuid
   * @example "9314a926-528c-403f-ae56-4b0d059381dd"
   */
  channelId?: string;
}

/**
 * Possible Values for Hub Characteristic "Availability" flags
 * @example "Available"
 */
export enum AvailabilityCharacteristic {
  Available = 'Available',
  Unavailable = 'Unavailable',
  Unsupported = 'Unsupported',
}

/**
 * The type of device integration.
 * All types besides ENDPOINT_APP will have profile populated.
 * If the type is DTH, the device implementation is a groovy Device Handler and the details are in the "dth" field.
 * If the type is ENDPOINT_APP, the device implementation is a SmartApp and the details are in the "app" field.
 * If the type is IR, the details are in the "ir" field.
 * If the type is IR_OCF, the details are in the "irOcf" field.
 * If the type is VIPER, the details are in the "viper" field.
 */
export enum DeviceIntegrationType {
  APP = 'APP',
  BLE = 'BLE',
  BLED2D = 'BLE_D2D',
  DTH = 'DTH',
  ENDPOINT_APP = 'ENDPOINT_APP',
  GROUP = 'GROUP',
  HUB = 'HUB',
  IR = 'IR',
  IR_OCF = 'IR_OCF',
  LAN = 'LAN',
  MATTER = 'MATTER',
  MOBILE = 'MOBILE',
  MQTT = 'MQTT',
  OCF = 'OCF',
  PENGYOU = 'PENGYOU',
  SHP = 'SHP',
  VIDEO = 'VIDEO',
  VIPER = 'VIPER',
  VIRTUAL = 'VIRTUAL',
  WATCH = 'WATCH',
  ZIGBEE = 'ZIGBEE',
  ZWAVE = 'ZWAVE',
  EDGE_CHILD = 'EDGE_CHILD',
}

/**
 * The location of a device on a floorplan map, if any.
 * @example {"coordinates":["1.0","2.0","3.0"],"rotation":["0","0","0"],"visible":true,"data":[{"extraData1":"some data"}]}
 */
export interface IndoorMap {
  /**
   * The coordinates to be used to map the device.
   * @maxItems 3
   * @minItems 3
   */
  coordinates?: number[];
  /**
   * The rotational data for the device.
   * @maxItems 3
   * @minItems 3
   */
  rotation?: number[];
  /** Whether or not the device is visible on the map. */
  visible?: boolean;
  /** Key value pairs to place additional information. */
  data?: Record<string, any>;
}

export interface Device {
  /**
   * The identifier for the device instance.
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  deviceId: string;
  /**
   * The identifier for the owner of the device instance.
   * @example "1c75f712-2c3e-4e51-970c-a42ae7aedbdc"
   */
  ownerId?: string;
  /**
   * The name that the device integration (Device Handler or SmartApp) defines for the device.
   * @example "color.light.100x"
   */
  name?: string;
  /**
   * The name that a user chooses for the device. This defaults to the same value as name.
   * @format ^([\S]{1}|[\S]+.*?[\S]+)$
   * @example "color.light.100x"
   */
  label?: string;
  /**
   * The device manufacturer code.
   * @example "010F-0B01-2002"
   */
  deviceManufacturerCode?: string;
  /**
   * The device manufacturer name.
   * @example "SmartThings"
   */
  manufacturerName: string;
  /**
   * The device model.
   * @example "FGMS-001"
   */
  deviceModel?: string;
  /**
   * An non-unique id that is used to help drive UI information.
   * @example "VD-STV_2018_K"
   */
  presentationId: string;
  /**
   * The ID of the Location with which the device is associated.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  locationId?: string;
  /**
   * The ID of the Room with which the device is associated. If the device is not associated with any room, then this field will be null.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0fd2b1ef-1b33-4a54-9153-65aca91e9660"
   */
  roomId?: string;
  /** The IDs of all locations this device is shared with. */
  sharedLocations?: SharedLocation[];
  /** The IDs of all compenents on the device. */
  components?: DeviceComponent[];
  /** The time when the device was created at. */
  createTime?: string;
  healthState?: IdLessHealthState;
  /** The id of the Parent device. */
  parentDeviceId?: string;
  /** Device details for all child devices of the device. */
  childDevices?: ChildDeviceRef[];
  profile?: DeviceProfileReference;
  /** Device Profile information for a SmartApp. This field will be empty if device type is not ENDPOINT_APP. */
  app?: AppDeviceDetails;
  /** Bluetooth device information. This field will be empty if device type is not BLE. */
  ble?: BleDeviceDetails;
  /** Bluetooth device to device information. This field will be empty if device type is not BLE_D2D. */
  bleD2D?: BleD2DDeviceDetails;
  /** Device Profile information for DTH. This field will be empty if device type is not DTH. */
  dth?: DthDeviceDetails;
  /** Device Profile information for Lan devices. This field will be empty if device type is not LAN. */
  lan?: LanDeviceDetails;
  /** Device Profile information for Zigbee devices. This field will be empty if device type is not ZIGBEE. */
  zigbee?: ZigbeeDeviceDetails;
  /** Device Profile information for Z-Wave devices. This field will be empty if device type is not ZWAVE. */
  zwave?: ZwaveDeviceDetails;
  /** Device Profile information for Matter devices. This field will be empty if the device type is not MATTER */
  matter?: MatterDeviceDetails;
  /** Device Profile information for Edge Child devices. This field will be empty if the device type is not EDGE_CHILD */
  edgeChild?: EdgeChildDeviceDetails;
  /** HUB device information. This field will be empty if the device type is not HUB. */
  hub?: HubDeviceDetails;
  /** MOBILE device information. This field will be empty if the device type is not MOBILE. */
  mobile?: MobileDeviceDetails;
  /** IR device information. This field will be empty if device type is not IR. */
  ir?: IrDeviceDetails;
  /** IR_OCF device information. This field will be empty if device type is not IR_OCF. */
  irOcf?: IrDeviceDetails;
  /** OCF device information. This field will be empty if device type is not OCF. */
  ocf?: OcfDeviceDetails;
  /** Viper device information. This field will be empty if device type is not VIPER. */
  viper?: ViperDeviceDetails;
  /** Group device information. This field will be empty if device type is not GROUP. */
  group?: GroupDeviceDetails;
  /** Virtual device information. This field will be empty if device type is not VIRTUAL. */
  virtual?: VirtualDeviceDetails;
  /**
   * The type of device integration.
   * All types besides ENDPOINT_APP will have profile populated.
   * If the type is DTH, the device implementation is a groovy Device Handler and the details are in the "dth" field.
   * If the type is ENDPOINT_APP, the device implementation is a SmartApp and the details are in the "app" field.
   * If the type is IR, the details are in the "ir" field.
   * If the type is IR_OCF, the details are in the "irOcf" field.
   * If the type is VIPER, the details are in the "viper" field.
   */
  type: DeviceIntegrationType;
  /**
   * A field to store an ID from a system external to SmartThings.
   * @maxLength 64
   * @example "Th13390"
   */
  externalId?: string;
  /**
   * *DEPRECATED* please use `presentationId`
   * Vendor id of the device, used for UI.
   */
  vid?: string;
  /**
   * *DEPRECATED* please use `manufacturerName`
   * Manufacturer model number, used for UI.
   */
  mnmn?: string;
  /** The OCF device type (resource), used for UI. */
  ocfDeviceType?: string;
  /** Restriction tier of the device, if any. */
  restrictionTier: number;
  /**
   * List of client-facing action identifiers that are currently permitted for the user.
   * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
   * If the value of this property is null (or absent), then no permission-related information is being provided.
   *   <ul>
   *   <li> w:devices - the user can change device details
   *   <li> w:devices:locationId - the user can move the device from a location
   *   <li> w:devices:roomId - the user can move or remove the device from a room
   *   <li> x:devices - the user can execute commands on the device
   *   <li> d:devices - the user can uninstall the device
   *   </ul>
   * @uniqueItems true
   */
  allowed?: 'w:devices' | 'w:devices:locationId' | 'w:devices:roomId' | 'x:devices' | 'd:devices';
  /** The location of a device on a floorplan map, if any. */
  indoorMap?: IndoorMap;
  /** list of possible icon this particular device can have */
  possibleIcons: PossibleIcon[];
  icons: Icons;
  subgroupIcons?: SubGroupIcon[];
  badgeIcons?: BadgeIcons;
  /** the device is movable to other location */
  movable: boolean;
  /** Will be true if the device hasn't been marked seen by the user */
  unseen: boolean;
  /** If true the device is marked as hidden for the calling user. */
  hidden: boolean;
}

export interface Icons {
  /** url of the colored icon */
  coloredIcon: string;
  /** url of the dimmed icon */
  dimmedIcon: string;
  /** url of the activated icon */
  activatedIcon: string;
  /** url of the inactivated icon */
  inactivatedIcon: string;
  /** url of the disconnected icon */
  disconnectedIcon: string;
  /** url of the running icon */
  runningIcon?: string;
  /** url of the quickBoard icon */
  quickBoardIcon: string;
  /** url of the animation icon */
  animationIcon?: string;
  /** url for the colored auto icon */
  coloredAutoIcon: string;
  /** url for the dimmed auto icon */
  dimmedAutoIcon: string;
  /** url for the running auto icon */
  runningAutoIcon: string;
  /** url of the disconnected auto icon */
  disconnectedAutoIcon: string;
  /** key of the current icon. Will be one of ones in possibleIcons. Can be null if possibleIcons is empty */
  iconKey?: string;
  /**
   * last time any of the icons in the object got updated
   * @format date-time
   */
  lastUpdateDate: string;
}

export interface SubGroupIcon {
  /** name of the group of icons identifying it */
  groupId: any;
  icons: Icons;
}

export interface PossibleIcon {
  /** url of the icon */
  url: string;
  /** key to send to the cloud for updated icon */
  key: string;
  /**
   * last time any of the icons in the object got updated
   * @format date-time
   */
  lastUpdateDate: string;
}

export interface IconData {
  /** key of the icon to set on the device */
  key: string;
}

export interface UpdateDeviceRequest {
  /**
   * The label for the Device.
   * @minLength 1
   * @maxLength 255
   * @example "Living room light"
   */
  label?: string;
  /**
   * The ID of the Location where the Device should be moved to.
   * Not all Devices support Location moves.
   * Moving between some Locations may be rejected depending on the data region used.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  locationId?: string;
  /**
   * The ID of the Room with which to associate the Device is associated.
   * The Room must be valid for the Location of the Device.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0fd2b1ef-1b33-4a54-9153-65aca91e9660"
   */
  roomId?: string;
  /** key of the icon to set on the device */
  iconKey?: string;
  /** The location of a device on a floorplan map, if any. */
  indoorMap?: IndoorMap;
}

export type BadgeIcons = BadgeIconData[];

export interface BadgeIconData {
  /** url of the colored badge icon */
  coloredIcon: string;
  /** url of the dimmed badge icon */
  dimmedIcon: string;
  /** url of the activated badge icon */
  activatedIcon: string;
  /** url of the inactivated badge icon */
  inactivatedIcon: string;
  /** url of the disconnected badge icon */
  disconnectedIcon: string;
  /** key of the current badge icon */
  iconKey: string;
  /**
   * last time any of the badge icons in the object got updated
   * @format date-time
   */
  lastUpdateDate: string;
}

/** The type of the device group */
export enum DeviceGroupType {
  LIGHTING = 'LIGHTING',
  GENERIC = 'GENERIC',
  UNDETERMINED = 'UNDETERMINED',
  VIDEO_CAMERA = 'VIDEO_CAMERA',
}

/** Listening type for the device. Optional. */
export enum MatterListeningType {
  ALWAYS = 'ALWAYS',
  SLEEPY = 'SLEEPY',
}

/** Hardware and Software version info for matter devices. Optional. */
export interface MatterVersion {
  /**
   * 16-bit hardware version. Optional.
   * @min 0
   * @max 65535
   * @example 771
   */
  hardware?: number;
  /** Label for the hardware version. Optional. */
  hardwareLabel?: string;
  /**
   * 32-bit software version. Optional.
   * @min 0
   * @max 4294967295
   * @example 50529027
   */
  software?: number;
  /** Label for the hardware version. Optional. */
  softwareLabel?: string;
}

/** List of network interfaces. Optional. */
export type MatterNetworkInterfaces = MatterNetworkInterface[];

/** Supported Network Interfaces of the Device */
export enum MatterNetworkInterface {
  THREAD = 'THREAD',
  WIFI = 'WIFI',
  ETHERNET = 'ETHERNET',
}

/** Available Matter endpoints */
export type MatterEndpoints = MatterEndpoint[];

/** Matter device endpoint */
export interface MatterEndpoint {
  /**
   * 16-bit identifier for the endpoint
   * @min 0
   * @max 65535
   * @example 771
   */
  endpointId?: number;
  /** List of device types for the endpoint */
  deviceTypes?: MatterEndpointDeviceType[];
}

/** Device type for a matter endpoint */
export interface MatterEndpointDeviceType {
  /**
   * 32-bit identifier for the device type
   * @min 0
   * @max 4294967295
   * @example 197379
   */
  deviceTypeId?: number;
}

/**
 * Determines whether or not to sync the child device's driver from its parent. Default is true.
 * @example true
 */
export type SyncDrivers = boolean;

export interface LocationUsersResponse {
  owner?: LocationUser;
  members?: LocationUser[];
  /** A list of members who have temporary access to this location (e.g. temporary building maintenance, SmartThings support staff, Partner support staff, etc.). */
  temporaryMembers?: MFULocationUser[];
  /** @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$ */
  locationId?: string;
}

export enum LocationUserType {
  MFU_LOCATION_USER = 'MFU_LOCATION_USER',
  STANDARD_LOCATION_USER = 'STANDARD_LOCATION_USER',
}

export interface LocationUser {
  type: LocationUserType;
  /**
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "e4190894-6ab2-4c80-a233-29fa9e87ae90"
   */
  uuid: string;
  /** @example "pcg38apioc" */
  samsungAccountId?: string;
  /** @example "Mickey Mouse" */
  name?: string;
}

/** A location user in an MFU Location */
export type MFULocationUser = LocationUser & object;

/** A location user in a non-MFU Location */
export type StandardLocationUser = LocationUser & {
  /**
   * Phone number or email. If the phone number is present on the User, this will be the phone number, otherwise falls back to email.
   * @example "mickey@mouse.com"
   */
  display?: string;
  /** The access type this user has to a location. One of: FULL, LIMITED, LIMITED_DEVICES, OWNER, UNKNOWN. */
  access: AccessType;
  /**
   * If true, the user has access to all devices in the location. Otherwise the user only has access to a limited
   * subset of devices. Will always be true if the user's access is FULL or LIMITED.
   * @example true
   */
  completeDeviceSet?: boolean;
  /**
   * An ISO 8601 date-time indicating the expiration of permissions for the user. Only applicable for users with
   * LIMITED and LIMITED_DEVICES access.
   * @format date-time
   */
  expiration?: string;
  /**
   * List of device UUIDs accessible to the LIMITED_DEVICES access user (i.e. devices with the r:devices action).
   * Will be non-null if access is LIMITED_DEVICES and caller is either owner or the user in question, null otherwise.
   * @example ["E8DF13FC-318C-42B4-9AA9-B07ADFFE5874","894F1489-EBE9-4C4F-9205-042E74E98D7A"]
   */
  sharedDevices?: string[];
};

export interface LocationUserAccessChangeRequest {
  /**
   * The access type this user has to a location. One of: FULL, LIMITED, LIMITED_DEVICES.
   * Requesting LIMITED_DEVICES access without a device list will apply the restrictedsharedevice grant
   * to all devices in the location.
   */
  access?: RequestedAccessType;
  /**
   * An ISO 8601 date-time indicating the expiration of permissions for the user.
   * This date must not be more than one year in the future.
   * If not provided, the limited access user's permission expiration will not be altered.
   * Applicable for users with LIMITED or LIMITED_DEVICES access.
   * @format date-time
   * @example "2023-08-15T00:00:00Z"
   */
  expiration?: string;
  /**
   * List of device UUIDs to be accessible to the limited access user.
   * If access is LIMITED_DEVICES and this is not provided, then all devices in the location will be
   * made available to the member. Applicable for users with LIMITED_DEVICES access.
   * @example ["E8DF13FC-318C-42B4-9AA9-B07ADFFE5874","894F1489-EBE9-4C4F-9205-042E74E98D7A"]
   */
  deviceList?: string[];
}

/** The access type this user has to a location. One of: FULL, LIMITED, LIMITED_DEVICES, OWNER, UNKNOWN. */
export enum AccessType {
  FULL = 'FULL',
  LIMITED = 'LIMITED',
  LIMITED_DEVICES = 'LIMITED_DEVICES',
  OWNER = 'OWNER',
  UNKNOWN = 'UNKNOWN',
}

/**
 * The access type this user has to a location. One of: FULL, LIMITED, LIMITED_DEVICES.
 * Requesting LIMITED_DEVICES access without a device list will apply the restrictedsharedevice grant
 * to all devices in the location.
 */
export enum RequestedAccessType {
  FULL = 'FULL',
  LIMITED = 'LIMITED',
  LIMITED_DEVICES = 'LIMITED_DEVICES',
}

export interface GetDevicesParams {
  /**
   * Determines whether the response should include data from MFU locations. Note that locations owned by MFU properties who are on the allow list will not be filtered out, regardless of the value of this param.
   * @default false
   */
  includeMfuLocations?: boolean;
  /**
   * If true will return hidden devices, else they will be filtered out.
   * @default false
   */
  includeHidden?: boolean;
  /**
   * If true will only return hidden devices, else no filtering will happen. This param supersedes includeHidden, so
   * when this is true only hidden devices will come back regardless of the value of includeHidden.
   * @default false
   */
  exclusiveToHidden?: boolean;
  /**
   * The device capabilities to filter the results by.
   * The capabilities are treated as an "and" so all capabilities must be present.
   */
  capability?: string[];
  /** The device locations to filter the results by. */
  locationId?: string[];
  /** The device ids to filter the results by. */
  deviceId?: string[];
  /**
   * Include the status of the device's capabilities where permission is adequate to view them.
   * This requires `r:devices` permission.
   */
  includeStatus?: boolean;
  /** Include the Health status of the device. This requires `r:devices` permission. */
  includeHealth?: boolean;
  /** The device types to filter the results by. */
  type?: string[];
  /** The device categories to filter the results by. */
  category?: string[];
  /**
   * Treat all capability filter query params as a logical "or" or "and" with a default of "and".
   * @default "and"
   */
  capabilitiesMode?: 'or' | 'and';
  /**
   * Restricted devices are hidden by default. This query parameter will reveal them. Device status will
   * not be provided if the token does not have sufficient access level to view the device status even
   * if includeStatus parameter is set to true.
   */
  includeRestricted?: boolean;
  /** Only list devices accessible by the given accessLevel. */
  accessLevel?: number;
  /**
   * User-level devices are devices that are not tied to a location, but are instead tied to the user. In order
   * to include these devices in the list, a flag is needed to differentiate from devices listed by location.
   */
  includeUserDevices?: boolean;
  /**
   * GROUP type devices are devices that represent Device Groups. In order to include these devices in the list,
   * a flag needs to be included.
   */
  includeGroups?: boolean;
  /** Use this in conjunction with includeUserDevices to get only User-level devices. */
  excludeLocationDevices?: boolean;
  /** Include the actions permitted by this token's access for each individual resource. */
  includeAllowedActions?: boolean;
}

export interface GetDeviceParams {
  /**
   * Determines whether the response should include data from MFU locations. Note that locations owned by MFU properties who are on the allow list will not be filtered out, regardless of the value of this param.
   * @default false
   */
  includeMfuLocations?: boolean;
  /**
   * Include the status of the device's capabilities where permission is adequate to view them.
   * This requires `r:devices` permission.
   */
  includeStatus?: boolean;
  /** Expand the child device details nested in the device's description. */
  includeChildren?: boolean;
  /** Include the actions permitted by this token's access for each individual resource. */
  includeAllowedActions?: boolean;
  /** The Device ID */
  deviceId: string;
}

export interface UpdateDeviceParams {
  /** Include the actions permitted by this token's access for each individual resource. */
  includeAllowedActions?: boolean;
  /** The Device ID */
  deviceId: string;
}

export interface GetLocationUserParams {
  /** The samsungAccountId for the user */
  samsungAccountId?: string;
  /**
   * The ID of the Location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /**
   * The id of the user
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  userId: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>;

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = 'https://client.smartthings.com';
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: 'same-origin',
    headers: {},
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join('&');
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => 'undefined' !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join('&');
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : '';
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string') ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== 'string' ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === 'object' && property !== null
            ? JSON.stringify(property)
            : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
      },
      signal: cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal,
      body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await (responseFormat !== 'json'
          ? response[responseFormat]()
          : response.text().then((text) => {
              try {
                return JSON.parse(text);
              } catch (e) {
                return text;
              }
            })
        )
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Client API
 * @version 6.0
 * @baseUrl https://client.smartthings.com
 *
 * API endpoints for mobile clients
 */
export class ClientV6Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  devices = {
    /**
     * @description Get a list of devices.
     *
     * @tags Devices
     * @name GetDevices
     * @summary List devices.
     * @request GET:/devices
     * @secure
     */
    getDevices: (query: GetDevicesParams, params: RequestParams = {}) =>
      this.request<PagedDevices, ErrorResponse>({
        path: `/devices`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a device's description.
     *
     * @tags Devices
     * @name GetDevice
     * @summary Get a device's description.
     * @request GET:/devices/{deviceId}
     * @secure
     */
    getDevice: ({ deviceId, ...query }: GetDeviceParams, params: RequestParams = {}) =>
      this.request<Device, ErrorResponse>({
        path: `/devices/${deviceId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update the properties of a Device. If the OAuth token used for this call is for a SmartApp that created the Device you are attempting to update, the call implicitly has permission for this API.
     *
     * @tags Devices
     * @name UpdateDevice
     * @summary Update a Device
     * @request PUT:/devices/{deviceId}
     * @secure
     */
    updateDevice: (
      { deviceId, ...query }: UpdateDeviceParams,
      updateDeviceRequest: UpdateDeviceRequest,
      params: RequestParams = {},
    ) =>
      this.request<Device, ErrorResponse>({
        path: `/devices/${deviceId}`,
        method: 'PUT',
        query: query,
        body: updateDeviceRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  locations = {
    /**
     * @description List users for a location.
     *
     * @tags Locations, Users
     * @name GetLocationUsers
     * @summary List users for a location.
     * @request GET:/locations/{locationId}/users
     * @secure
     */
    getLocationUsers: (locationId: string, params: RequestParams = {}) =>
      this.request<LocationUsersResponse, any>({
        path: `/locations/${locationId}/users`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get user for a location. Caller must have access to the location.
     *
     * @tags Locations, Users
     * @name GetLocationUser
     * @summary Get user for location.
     * @request GET:/locations/{locationId}/users/{userId}
     * @secure
     */
    getLocationUser: ({ locationId, userId, ...query }: GetLocationUserParams, params: RequestParams = {}) =>
      this.request<LocationUser, any>({
        path: `/locations/${locationId}/users/${userId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns a list of all users for all locations this user is a member of.
     *
     * @tags Locations, Users
     * @name GetAllLocationUsers
     * @summary Get all users for all locations a user owns.
     * @request GET:/locations/users
     * @secure
     */
    getAllLocationUsers: (params: RequestParams = {}) =>
      this.request<LocationUsersResponse[], ErrorResponse>({
        path: `/locations/users`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update the user's access for a given location. Can change the member's grant between full/limited, update which devices in the location should be shared with the user, and/or set the expiration date for the member's permissions to expire. The caller must be the owner of the location.
     *
     * @tags Locations, Users
     * @name UpdateLocationUserAccess
     * @summary Update User's Access.
     * @request PUT:/locations/{locationId}/users/{userId}/access
     * @secure
     */
    updateLocationUserAccess: (
      locationId: string,
      userId: string,
      accessChangeRequest: LocationUserAccessChangeRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/locations/${locationId}/users/${userId}/access`,
        method: 'PUT',
        body: accessChangeRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
}
